const normalize = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function matchesCareItem(text, itemState, query, selectedState = 'all') {
    if (selectedState !== 'all' && itemState !== selectedState) return false;
    const source = normalize(text);
    const search = normalize(query).trim();
    if (!search) return true;
    if (/^[\d.\s-]+$/.test(search)) return source.replace(/\D/g, '').includes(search.replace(/\D/g, ''));
    return search.split(/\s+/).every(word => source.includes(word));
}

export function initCareLists(root = document) {
    root.querySelectorAll('[data-care-list]').forEach(list => {
        if (list.dataset.careListBound) return;
        list.dataset.careListBound = 'true';
        const search = list.querySelector('[data-care-list-search]');
        const buttons = [...list.querySelectorAll('[data-care-list-state]')];
        let state = list.dataset.careListDefault || 'all';
        const update = () => {
            const rows = [...list.querySelectorAll('[data-care-item]')];
            let visible = 0;
            for (const row of rows) {
                const match = matchesCareItem(row.dataset.careItem, row.dataset.careItemState, search?.value, state);
                row.hidden = !match;
                if (match) visible++;
            }
            for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.careListState === state));
            const count = list.querySelector('[data-care-list-count]');
            if (count) count.textContent = `${visible} de ${rows.length} resultados`;
            const empty = list.querySelector('[data-care-list-empty]');
            if (empty) empty.hidden = visible !== 0 || rows.length === 0;
        };
        search?.addEventListener('input', update);
        buttons.forEach(button => button.addEventListener('click', () => { state = button.dataset.careListState; update(); }));
        list.querySelector('[data-care-list-reset]')?.addEventListener('click', () => {
            state = 'all'; if (search) search.value = ''; update(); search?.focus();
        });
        update();
    });
}
if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCareLists());
    else initCareLists();
    document.addEventListener('htmx:afterSwap', () => initCareLists());
}
